<template>
  <div 
    :class="[
      'bg-gradient-to-br from-primary-100 to-primary-200 rounded-full flex items-center justify-center shadow-inner',
      sizeClasses
    ]"
  >
    <div class="text-center">
      <svg 
        :class="[
          'text-primary-400 mx-auto',
          iconSizeClasses
        ]" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultAvatar',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeClasses() {
      const sizes = {
        small: 'w-12 h-12',
        medium: 'w-16 h-16',
        large: 'w-32 h-32'
      }
      return sizes[this.size]
    },
    iconSizeClasses() {
      const sizes = {
        small: 'w-6 h-6',
        medium: 'w-8 h-8',
        large: 'w-16 h-16'
      }
      return sizes[this.size]
    }
  }
}
</script>
